'use client';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/** 專門讀寫 ?compare=xx,yy,zz */
export function useCompareParams() {
    const [searchParams, setSearchParams] = useSearchParams();

    /** 目前 URL 裡的料號陣列 */
    const compareItemPns = useMemo(() => {
        const raw = searchParams.get('compare');
        return raw ? raw.split(',').filter(Boolean) : [];
    }, [searchParams]);

    /** 加 / 刪單一料號；checked = true 表示「要勾選」 */
    const togglePn = useCallback(
        (pn: string, checked: boolean) => {
            const next = checked
                ? Array.from(new Set([...compareItemPns, pn]))
                : compareItemPns.filter((x) => x !== pn);

            const nextParams = new URLSearchParams(searchParams);
            if (next.length) nextParams.set('compare', next.join(','));
            else nextParams.delete('compare');

            // setSearchParams(nextParams, { replace: true });
            setSearchParams(nextParams);
        },
        [compareItemPns, searchParams, setSearchParams]
    );

    /** 全清空 */
    const clearAll = useCallback(() => {
        const next = new URLSearchParams(searchParams);
        next.delete('compare');
        setSearchParams(next, { replace: true });
    }, [searchParams, setSearchParams]);

    return { compareItemPns, togglePn, clearAll };
}
